import React from 'react'
import { Tooltip as UcTooltip } from '@lightspeed/unified-components-helios-theme/react'
import type { TooltipProps } from '@lightspeed/unified-components-helios-theme/react'
import { useUcPortalTarget } from './useUcPortalTarget'

/**
 * Unified Components Tooltip pre-configured for use across WebRegister.
 * Provides consistent default props so all tooltips in WebRegister look and behave the same.
 * All props can be overridden by the consumer if needed.
 *
 * portalTargetRef is needed to render the tooltip within `uc-base` container
 */
export const Tooltip: React.FC<TooltipProps> = props => {
  const { portalTargetRef } = useUcPortalTarget()

  return (
    <UcTooltip
      portalTargetRef={portalTargetRef}
      closeDelay={200}
      openDelay={500}
      customClasses={{ content: ['max-w-80'] }}
      {...props}
    />
  )
}
